(ns frontend.ui.component.lp-portal.report.esg.key-perf-indicators.view
  (:require
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.table.view :refer [table-from-values editable-table]]
   [frontend.ui.component.lp-portal.text-content.view :as text-content] 
   [frontend.ui.component.select-input.view :as select-input-group]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.component.lp-portal.report.esg.gresb :as esg-gresb]
   [frontend.ui.component.dynamic-table.view :as dynamic-table]))

(defn key-perf-indicators-card
  [{:keys [figures show-gresb-logo?] :as key-perf-indicators} 
   _gresb {:keys [edit-mode? _save-text] :as props}] 
  (when (or edit-mode?
            (some->> key-perf-indicators
                     :figures
                     :data
                     (seq)))
    (let [labels (cons nil (:column-order figures))
          data-rows (if (map? (:data figures)) ;;To make sure old data model still works
                      (->> figures
                           :data
                           (mapv (fn [[row-label row-data]]
                                   (cons row-label
                                         (->> (:column-order figures)
                                              (mapv (fn [k]
                                                      (get row-data k))))))))
                      (:data figures))
          data (cons labels data-rows)]
      (if show-gresb-logo?
        [card
         {:title "Key performance indicators"}
         [:<>
          [editable-table key-perf-indicators props (table-from-values false data nil)]
          (text-content/optional-footnote key-perf-indicators props)]
         [:div
          {:style {:display "flex"
                   :flex    "1 1 auto"
                   :justify-content "center"}}
          [:img
           {:style {:margin "1em 4em"
                    :flex   "1 1 auto"}
            :src   "https://static.zapflow.com/app/img/lp_portal/capman/GRESB_vert.png"}]]]
        [card
         {:title "Key performance indicators"}
         [:<>
          [editable-table key-perf-indicators props (table-from-values false data nil)]
          (text-content/optional-footnote key-perf-indicators props)]]))))

(defn key-perf-indicators-card-re
  [{:keys [_figures] :as key-perf-indicators} gresb {:keys [edit-mode? save-text] :as props}]
  (when (or edit-mode?
            (some->> key-perf-indicators
                                :figures
                                :data
                                (seq)))
    (let [image-src (esg-gresb/get-image gresb)
          gresb-options (->> esg-gresb/gresb-configs-2025
                             (map (fn [c]
                                    [(:key c) (:label c)]))
                             (into {}))]
      (if (or image-src
              edit-mode?)
        [card
         {:title "Key performance indicators"}
         [:<>
          [editable-table key-perf-indicators props
           (dynamic-table/dynamic-table
            {:parsed-data (:figures key-perf-indicators)
             :sub-heading-color (theme/color [:dynamic-table :heading-row :bg])
             :odd-row-background-color (theme/color [:dynamic-table :odd-row :bg])
             :even-row-background-color (theme/color [:dynamic-table :even-row :bg])})]
          (text-content/optional-footnote key-perf-indicators props)]
         [:div
          {:style {:display        "flex"
                   :flex           "1 1 auto"
                   :justify-content "center"
                   :flex-direction "column"}}
          (when edit-mode?
            [select-input-group/select-input
             {:value     gresb
              :on-change #(save-text [:esg :gresb] %)}
             gresb-options])
          (when image-src
            [:img
             {:style {:margin "1em 4em"
                      :flex   "1 1 auto"}
              :src   image-src}])]]
        [card
         {:title "Key performance indicators"}
         [:<>
          [editable-table key-perf-indicators props
           (dynamic-table/dynamic-table
             {:parsed-data (:figures key-perf-indicators)
              :sub-heading-color (theme/color [:dynamic-table :heading-row :bg])
              :odd-row-background-color (theme/color [:dynamic-table :odd-row :bg])
              :even-row-background-color (theme/color [:dynamic-table :even-row :bg])})]
          (text-content/optional-footnote key-perf-indicators props)]]))))
